(function(){
  'use strict';

  /* ---------- Product / variant data (page produit uniquement) ---------- */
  var variantsEl = document.getElementById('product-variants-json');
  var variants = [];
  var productMeta = window.BossSecretProduct || { colorOptionIndex: -1, sizeOptionIndex: -1 };
  if(variantsEl){
    try { variants = JSON.parse(variantsEl.textContent); } catch(e){ variants = []; }
  }
  var colorImagesEl = document.getElementById('product-color-images-json');
  var colorImages = {};
  if(colorImagesEl){
    try { colorImages = JSON.parse(colorImagesEl.textContent); } catch(e){ colorImages = {}; }
  }

  function findVariant(colorValue, sizeValue){
    var colorIdx = productMeta.colorOptionIndex;
    var sizeIdx = productMeta.sizeOptionIndex;
    var optionKeys = ['option1', 'option2', 'option3'];
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var colorOk = colorIdx < 0 || !colorValue || (v[optionKeys[colorIdx]] && v[optionKeys[colorIdx]].toLowerCase() === colorValue.toLowerCase());
      var sizeOk = sizeIdx < 0 || !sizeValue || v[optionKeys[sizeIdx]] === sizeValue;
      if(colorOk && sizeOk){ return v; }
    }
    return null;
  }

  function formatMoney(cents){
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  var colorNames = { blanc:'Blanc', camel:'Camel', noir:'Noir', rouge:'Rouge' };
  var selectedSize = null;
  var selectedQty = 1;

  var swatches = document.querySelectorAll('.swatch-btn:not(.soon)');
  var note = document.getElementById('swatch-note');
  var mainImage = document.getElementById('main-product-image');
  var flatImage = document.getElementById('hero-flat-photo');
  var flatPending = document.getElementById('hero-flat-pending');
  var stickyPhoto = document.getElementById('sticky-photo');
  var activeSwatch = document.querySelector('.swatch-btn.active');
  var currentColor = activeSwatch ? activeSwatch.getAttribute('data-color') : null;

  function applyColorVisuals(colorValue){
    var wornUrl = colorImages[colorValue + '_worn'];
    var flatUrl = colorImages[colorValue + '_flat'];
    if(mainImage && wornUrl){ mainImage.src = wornUrl; }
    if(stickyPhoto && wornUrl){ stickyPhoto.style.backgroundImage = "url('" + wornUrl + "')"; }
    if(flatImage){
      if(flatUrl){
        flatImage.src = flatUrl;
        flatImage.style.display = 'block';
        if(flatPending){ flatPending.style.display = 'none'; }
      } else {
        flatImage.style.display = 'none';
        if(flatPending){ flatPending.style.display = 'flex'; }
      }
    }
  }

  swatches.forEach(function(btn){
    btn.addEventListener('click', function(){
      swatches.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var c = btn.getAttribute('data-color');
      currentColor = c;
      var extra = c === 'blanc' ? ' — testé et approuvé, aucune transparence.' : '';
      if(note){ note.innerHTML = 'Couleur choisie : <strong>' + (colorNames[c] || c) + '</strong>' + extra; }
      applyColorVisuals(c);
      var stickyColorSelect = document.getElementById('sticky-color-select');
      if(stickyColorSelect){ stickyColorSelect.value = c; }
    });
  });

  /* red "coming soon" swatch -> scroll to the waitlist section */
  var soonBtn = document.querySelector('.swatch-btn.soon');
  if(soonBtn){
    soonBtn.addEventListener('click', function(){
      var target = document.getElementById('bientot-rouge');
      if(target){ target.scrollIntoView({behavior:'smooth', block:'center'}); }
      var emailInput = document.querySelector('#bientot-rouge input[type="email"]');
      if(emailInput){ setTimeout(function(){ emailInput.focus(); }, 400); }
    });
  }

  /* ---------- Size selector (hero) ---------- */
  var heroSizeBtns = document.querySelectorAll('#hero-sizes .size-btn');
  var heroSizeNote = document.getElementById('hero-size-note');
  heroSizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      heroSizeBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      selectedSize = btn.getAttribute('data-size');
      if(heroSizeNote){
        heroSizeNote.innerHTML = 'Taille sélectionnée : <strong>' + selectedSize + '</strong>';
        heroSizeNote.style.color = '';
      }
      updateCtaLabel();
      var stickySizeSelect = document.getElementById('sticky-size-select');
      if(stickySizeSelect){ stickySizeSelect.value = selectedSize; }
    });
  });

  /* ---------- Bundle selector ---------- */
  var bundleBtns = document.querySelectorAll('.bundle-btn');
  var ctaBtn = document.getElementById('cta-btn');
  function updateCtaLabel(){
    if(!ctaBtn) return;
    var active = document.querySelector('.bundle-btn.active');
    var qty = active ? active.getAttribute('data-qty') : '1';
    selectedQty = parseInt(qty, 10) || 1;
    var priceText = active ? active.querySelector('.p').textContent : ctaBtn.getAttribute('data-default-text');
    var label = qty + " L'Iconique";
    ctaBtn.textContent = 'Ajouter ' + label + ' — ' + priceText;
  }
  bundleBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      bundleBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      updateCtaLabel();
    });
  });

  /* ---------- Add to cart (real Shopify cart) ---------- */
  var cartMsg = document.getElementById('cart-msg');
  function addToCart(variantId, quantity, onDone){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
      .then(function(result){ onDone(result.ok, result.data); })
      .catch(function(){ onDone(false, null); });
  }

  if(ctaBtn){
    ctaBtn.addEventListener('click', function(){
      if(!selectedSize){
        if(heroSizeNote){
          heroSizeNote.innerHTML = "⚠️ Choisis ta taille avant d'ajouter au panier";
          heroSizeNote.style.color = 'var(--accent-text)';
        }
        var sizesEl = document.getElementById('hero-sizes');
        if(sizesEl){ sizesEl.scrollIntoView({behavior:'smooth', block:'center'}); }
        return;
      }
      var v = findVariant(currentColor, selectedSize);
      if(!v){
        if(cartMsg){ cartMsg.textContent = 'Cette combinaison couleur/taille n\'existe pas encore.'; cartMsg.className = 'cart-msg error'; }
        return;
      }
      if(v.available === false){
        if(cartMsg){ cartMsg.textContent = 'Cette taille est épuisée pour le moment.'; cartMsg.className = 'cart-msg error'; }
        return;
      }
      var originalText = ctaBtn.textContent;
      ctaBtn.textContent = ctaBtn.getAttribute('data-adding-text') || 'Ajout en cours…';
      ctaBtn.disabled = true;
      addToCart(v.id, selectedQty, function(ok, data){
        ctaBtn.disabled = false;
        if(ok){
          ctaBtn.textContent = '✅ Ajouté au panier';
          if(cartMsg){ cartMsg.textContent = "C'est dans ton panier ! Continue tes achats ou finalise ta commande."; cartMsg.className = 'cart-msg success'; }
          setTimeout(function(){ ctaBtn.textContent = originalText; }, 2200);
        } else {
          ctaBtn.textContent = originalText;
          var msg = (data && data.description) ? data.description : "Un souci est survenu, réessaie.";
          if(cartMsg){ cartMsg.textContent = msg; cartMsg.className = 'cart-msg error'; }
        }
      });
    });
  }

  /* ---------- Secondary "mid-page" buy buttons -> scroll to hero and open size picker ---------- */
  document.querySelectorAll('.mid-cta').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var produit = document.getElementById('produit');
      if(produit){ produit.scrollIntoView({behavior:'smooth', block:'start'}); }
      setTimeout(function(){ if(ctaBtn){ ctaBtn.click(); } }, 450);
    });
  });

  /* ---------- Sticky bar: color/size selects + direct-to-checkout ---------- */
  var stickyColorSelect = document.getElementById('sticky-color-select');
  var stickySizeSelect = document.getElementById('sticky-size-select');
  if(stickyColorSelect){
    stickyColorSelect.value = currentColor || 'blanc';
    stickyColorSelect.addEventListener('change', function(){
      var target = document.querySelector('.swatch-btn[data-color="' + stickyColorSelect.value + '"]');
      if(target){ target.click(); }
    });
  }
  if(stickySizeSelect){
    stickySizeSelect.addEventListener('change', function(){
      if(!stickySizeSelect.value) return;
      var target = document.querySelector('#hero-sizes .size-btn[data-size="' + stickySizeSelect.value + '"]');
      if(target){ target.click(); }
    });
  }

  var stickyCtaBtn = document.getElementById('sticky-cta-btn');
  if(stickyCtaBtn){
    stickyCtaBtn.addEventListener('click', function(){
      var size = stickySizeSelect ? stickySizeSelect.value : selectedSize;
      var color = stickyColorSelect ? stickyColorSelect.value : currentColor;
      if(!size){
        if(stickySizeSelect){ stickySizeSelect.style.borderColor = 'var(--accent-deep)'; stickySizeSelect.focus(); }
        return;
      }
      var v = findVariant(color, size);
      if(!v || v.available === false){
        alert("Cette combinaison n'est pas disponible pour le moment.");
        return;
      }
      stickyCtaBtn.disabled = true;
      addToCart(v.id, 1, function(ok){
        stickyCtaBtn.disabled = false;
        if(ok){
          window.location.href = '/checkout';
        } else {
          alert("Un souci est survenu, réessaie.");
        }
      });
    });
  }

  /* ---------- Sticky bar visibility ---------- */
  var stickyBar = document.getElementById('sticky-bar');
  var heroImageEl = document.querySelector('.hero-image');
  if(stickyBar && heroImageEl && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      stickyBar.classList.toggle('show', !entries[0].isIntersecting);
    }, {rootMargin:'-80px 0px 0px 0px'});
    io.observe(heroImageEl);
  }

  /* ---------- Real "today" date, used by the free-shipping messages ---------- */
  (function(){
    var todayStr = new Date().toLocaleDateString('fr-FR', {weekday:'long', day:'numeric', month:'long'});
    ['free-ship-date', 'free-ship-date-hero', 'free-ship-date-sticky'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.textContent = todayStr; }
    });
  })();

  /* ---------- Delivery date estimate (business days, daily cutoff) ---------- */
  (function(){
    var el = document.getElementById('delivery-estimate');
    if(!el) return;
    var cutoffHour = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingCutoffHour) || 22, 10);
    var daysLow = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingDaysLow) || 3, 10);
    var daysHigh = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingDaysHigh) || 5, 10);
    function addBusinessDays(date, days){
      var d = new Date(date);
      var added = 0;
      while(added < days){
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if(day !== 0 && day !== 6){ added++; }
      }
      return d;
    }
    function fmt(d){ return d.toLocaleDateString('fr-FR', {weekday:'short', day:'numeric', month:'short'}); }
    var now = new Date();
    var base = new Date(now);
    if(now.getHours() >= cutoffHour){ base.setDate(base.getDate() + 1); }
    var low = addBusinessDays(base, daysLow);
    var high = addBusinessDays(base, daysHigh);
    el.innerHTML = '📦 Commande avant ' + cutoffHour + 'h aujourd\'hui : livraison estimée entre le <strong>' + fmt(low) + '</strong> et le <strong>' + fmt(high) + '</strong>.';
  })();

  /* ---------- Restock countdown (persisted per visiteuse) ---------- */
  (function(){
    var el = document.getElementById('restock-countdown');
    if(!el) return;
    var KEY = 'bs_restock_target';
    var target;
    try {
      var stored = localStorage.getItem(KEY);
      target = stored ? parseInt(stored, 10) : null;
    } catch(e){ target = null; }
    if(!target || isNaN(target)){
      target = Date.now() + 7 * 24 * 60 * 60 * 1000;
      try { localStorage.setItem(KEY, String(target)); } catch(e){}
    }
    function tick(){
      var diff = target - Date.now();
      if(diff <= 0){
        target = Date.now() + 7 * 24 * 60 * 60 * 1000;
        try { localStorage.setItem(KEY, String(target)); } catch(e){}
        diff = target - Date.now();
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      function pad(n){ return n < 10 ? '0' + n : n; }
      el.textContent = d + 'j ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(function(item){
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if(!q || !a) return;
    if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
    q.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(it){
        it.classList.remove('open');
        it.querySelector('.faq-a').style.maxHeight = null;
      });
      if(!isOpen){
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Size quiz modal ---------- */
  var quizModal = document.getElementById('quiz-modal');
  var openQuizBtn = document.getElementById('open-quiz');
  if(openQuizBtn && quizModal){
    openQuizBtn.addEventListener('click', function(){ quizModal.classList.add('open'); });
  }
  var heroQuizLink = document.getElementById('hero-size-quiz-link');
  if(heroQuizLink && quizModal){
    heroQuizLink.addEventListener('click', function(e){ e.preventDefault(); quizModal.classList.add('open'); });
  }
  var quizCloseBtn = document.getElementById('quiz-close');
  if(quizCloseBtn && quizModal){
    quizCloseBtn.addEventListener('click', function(){ quizModal.classList.remove('open'); });
    quizModal.addEventListener('click', function(e){ if(e.target === quizModal){ quizModal.classList.remove('open'); } });
  }
  var tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      tabBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var tab = btn.getAttribute('data-tab');
      document.querySelectorAll('.tab-panel').forEach(function(p){
        p.classList.toggle('active', p.getAttribute('data-panel') === tab);
      });
    });
  });

  /* Size quiz "conseil" form — shows the recommendation instantly, then sends the real signup in the background */
  var sizeQuizForm = document.getElementById('size-quiz-form');
  if(sizeQuizForm){
    sizeQuizForm.addEventListener('submit', function(e){
      var heightInput = document.getElementById('height-input');
      var result = document.getElementById('height-result');
      var h = heightInput ? parseFloat(heightInput.value) : NaN;
      if(!h || h < 140 || h > 210){
        e.preventDefault();
        if(result){ result.innerHTML = 'Indique ta taille en cm pour voir ton profil (par exemple 165).'; result.classList.add('show'); }
        return;
      }
      var email = document.getElementById('quiz-email-input');
      if(!email || !email.value || email.value.indexOf('@') === -1){
        e.preventDefault();
        if(result){ result.innerHTML = 'Indique ton email pour recevoir ta recommandation.'; result.classList.add('show'); }
        return;
      }
      var profile, size;
      if(h < 160){ profile = 'Petite'; size = 'XS / S'; }
      else if(h < 170){ profile = 'Standard'; size = 'S / M'; }
      else if(h < 180){ profile = 'Grande'; size = 'M / L'; }
      else { profile = 'Extra Grande'; size = 'L / XL'; }

      var weight = (document.getElementById('weight-input') || {}).value || '-';
      var usualSize = (document.getElementById('usual-size-input') || {}).value || '-';
      var sport = (document.getElementById('sport-input') || {}).value || '-';
      var diet = (document.getElementById('diet-input') || {}).value || '-';
      var work = (document.getElementById('work-input') || {}).value || '-';
      var noteInput = document.getElementById('quiz-note-input');
      if(noteInput){
        noteInput.value = 'Quiz taille — Taille:' + h + 'cm, Poids:' + weight + 'kg, Taille habituelle:' + usualSize +
          ', Sport:' + sport + ', Alimentation:' + diet + ', Travail:' + work + ', Profil calculé:' + profile;
      }

      var usualNote = (usualSize && usualSize !== '-') ? ' Comme tu fais habituellement du ' + usualSize + ", c'est cohérent avec ce profil." : '';
      if(result){
        result.innerHTML = 'Tu es dans notre profil <strong>' + profile + '</strong>. On te recommande de partir sur une taille <strong>' + size +
          "</strong> — entre deux tailles ? Prends toujours la taille au-dessus pour plus de confort." + usualNote +
          ' <em>(Recommandation indicative, à affiner avec notre tableau détaillé.)</em> On vient aussi de t\'envoyer ça par email.';
        result.classList.add('show');
      }

      /* Keep the visitor on the page: send the real signup to Shopify in the background */
      e.preventDefault();
      fetch(sizeQuizForm.action, { method: 'POST', body: new FormData(sizeQuizForm) }).catch(function(){});
    });
  }
  var directSizeBtns = document.querySelectorAll('.tab-panel[data-panel="direct"] .size-btn');
  directSizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      directSizeBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var result = document.getElementById('size-result');
      if(result){
        result.innerHTML = 'Tu as choisi la taille <strong>' + btn.getAttribute('data-size') + '</strong>.';
        result.classList.add('show');
      }
      var heroTarget = document.querySelector('#hero-sizes .size-btn[data-size="' + btn.getAttribute('data-size') + '"]');
      if(heroTarget){ heroTarget.click(); }
    });
  });

  /* ---------- Colorimetry quiz ---------- */
  var colorModal = document.getElementById('color-quiz-modal');
  var openColorQuiz = document.getElementById('open-color-quiz');
  var colorQuizClose = document.getElementById('color-quiz-close');
  var colorQ1 = document.getElementById('color-quiz-q1');
  var colorQ2 = document.getElementById('color-quiz-q2');
  var colorResult = document.getElementById('color-quiz-result');
  var toneScore = { chaud:0, froid:0, neutre:0 };
  var colorReasons = {
    chaud:'les sous-tons chauds rayonnent dans les teintes terreuses et dorées.',
    froid:'les sous-tons froids adorent les contrastes nets et affirmés.',
    neutre:'les sous-tons neutres se marient avec (presque) tout — mais le blanc met particulièrement en valeur cet équilibre.'
  };
  var colorTargetLabel = { chaud:'camel', froid:'noir', neutre:'blanc' };
  function resetColorQuiz(){
    toneScore = { chaud:0, froid:0, neutre:0 };
    if(colorQ1) colorQ1.style.display = 'block';
    if(colorQ2) colorQ2.style.display = 'none';
    if(colorResult){ colorResult.classList.remove('show'); colorResult.innerHTML = ''; }
  }
  if(openColorQuiz && colorModal){
    openColorQuiz.addEventListener('click', function(){ resetColorQuiz(); colorModal.classList.add('open'); });
    if(colorQuizClose){ colorQuizClose.addEventListener('click', function(){ colorModal.classList.remove('open'); }); }
    colorModal.addEventListener('click', function(e){ if(e.target === colorModal){ colorModal.classList.remove('open'); } });
    if(colorQ1){
      colorQ1.querySelectorAll('.tone-swatch').forEach(function(btn){
        btn.addEventListener('click', function(){
          toneScore[btn.getAttribute('data-tone')] += 2;
          colorQ1.style.display = 'none';
          if(colorQ2) colorQ2.style.display = 'block';
        });
      });
    }
    if(colorQ2){
      colorQ2.querySelectorAll('.tone-swatch').forEach(function(btn){
        btn.addEventListener('click', function(){
          toneScore[btn.getAttribute('data-tone')] += 1;
          colorQ2.style.display = 'none';
          var winner = 'neutre';
          if(toneScore.chaud >= toneScore.froid && toneScore.chaud >= toneScore.neutre){ winner = 'chaud'; }
          else if(toneScore.froid >= toneScore.chaud && toneScore.froid >= toneScore.neutre){ winner = 'froid'; }
          var colorKey = colorTargetLabel[winner];
          var colorLabel = colorNames[colorKey] || colorKey;
          if(colorResult){
            colorResult.innerHTML = 'Pour toi, on recommande le <strong>' + colorLabel + '</strong> — ' + colorReasons[winner] +
              ' <em>(Recommandation indicative, fais confiance à ce que tu préfères porter !)</em>';
            colorResult.classList.add('show');
          }
          var targetSwatch = document.querySelector('.swatch-btn[data-color="' + colorKey + '"]');
          if(targetSwatch){ targetSwatch.click(); }
          setTimeout(function(){ colorModal.classList.remove('open'); }, 2200);
        });
      });
    }
  }

  /* ---------- Live chat widget (aperçu — non connecté) ---------- */
  var chatBubble = document.getElementById('chat-bubble');
  var chatPanel = document.getElementById('chat-panel');
  var chatClose = document.getElementById('chat-close');
  var chatBody = document.getElementById('chat-body');
  var chatForm = document.getElementById('chat-form');
  var chatInput = document.getElementById('chat-input');
  var chatReplies = [
    'Merci pour ton message ! Notre équipe te répond généralement en quelques minutes.',
    'Bonne question — tu trouveras le guide des tailles juste au-dessus, avec un quiz pour être sûre de ton choix.',
    'On livre partout en Europe en 3 à 5 jours, retours gratuits sous 30 jours si besoin !',
    "Je transmets ça à l'équipe, on revient vers toi par email très vite."
  ];
  function addChatMsg(text, who){
    var div = document.createElement('div');
    div.className = 'chat-msg ' + (who === 'user' ? 'chat-msg-user' : 'chat-msg-bot');
    div.textContent = text;
    chatBody.appendChild(div);
    chatBody.scrollTop = chatBody.scrollHeight;
  }
  if(chatBubble && chatPanel){
    chatBubble.addEventListener('click', function(){
      chatPanel.classList.toggle('open');
      if(chatPanel.classList.contains('open') && chatInput){ chatInput.focus(); }
    });
    if(chatClose){ chatClose.addEventListener('click', function(){ chatPanel.classList.remove('open'); }); }
  }
  if(chatForm){
    chatForm.addEventListener('submit', function(e){
      e.preventDefault();
      var val = chatInput.value.trim();
      if(!val) return;
      addChatMsg(val, 'user');
      chatInput.value = '';
      setTimeout(function(){
        addChatMsg(chatReplies[Math.floor(Math.random() * chatReplies.length)], 'bot');
      }, 700);
    });
  }

  /* ---------- Subtle 3D tilt on product photos and feature cards ---------- */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!prefersReducedMotion){
    document.querySelectorAll('.hero-image, .feature-card').forEach(function(el){
      el.style.transformStyle = 'preserve-3d';
      el.style.willChange = 'transform';
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(700px) rotateY(' + (px * 8) + 'deg) rotateX(' + (py * -8) + 'deg) scale(1.015)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transform = 'perspective(700px) rotateY(0) rotateX(0) scale(1)';
      });
    });
  }
})();
